module.exports = __webpack_public_path__ + "img/EXTERIOR-SCROSS-5.5a529b6e.jpg";